export const isArmIdMatch = (a, b) => {
  let bIds = b.split(".")
  return a.includes(bIds[bIds.length - 1])
}

export const getBaselinePeriod = (formData) => {
  if (formData?.results?.participant_flow?.participant_flow_table?.eudract_periods) {
    return formData.results.participant_flow.participant_flow_table.eudract_periods.find(
      (period) => period?.baseline_period === "Yes"
    )
  }

  return null
}

export const isGroupInBaselinePeriod = (formData, group) => {
  if (formData?.results?.participant_flow?.participant_flow_table?.eudract_periods) {
    let baselinePeriod = formData.results.participant_flow.participant_flow_table.eudract_periods.find(
      (period) => period?.baseline_period === "Yes"
    )

    if (
      baselinePeriod?.arms.find((arm) => {
        let periodArmIds = arm.id.split(".")
        let compareGroup = group.id.split(".")
        if (periodArmIds[periodArmIds.length - 1] === compareGroup[compareGroup.length - 1]) {
          return true
        }
        return false
      })
    ) {
      return true
    }
  }

  return false
}

export const schemaOptionsFilter = (arr, registry) => {
  if (!arr) return arr

  return arr.map((item) => {
    if (typeof item === "object" && !Array.isArray(item) && item !== null && registry) {
      if (item?.registries?.[registry]) {
        return {
          value: item.value,
          label: item.registries[registry],
        }
      } else {
        return item
      }
    }

    return item
  })
}

export const findSchemaOptionsValue = (arr, value, registry) => {
  if (!arr) return value

  let returnValue = value

  arr.forEach((item) => {
    if (typeof item === "object" && !Array.isArray(item) && item !== null && registry) {
      if (value === item.value && item?.registries?.[registry]) {
        returnValue = item?.registries?.[registry]
      }
    }
  })

  return returnValue
}

export const isArmTitleAndDescEqual = (a, b) => {
  return a?.title === b?.title && a?.description === b?.description
}

export const findArmsByTitleAndDescription = (arr = [], arm) => {
  if (!arr || arr.length === 0) return []
  return arr.filter((item) => {
    return item.title === arm.title && item.description === arm.description
  })
}

export const findArmByTitleAndDescription = (arr = [], arm) => {
  if (!arr || arr.length === 0) return null
  return arr.find((item) => {
    return item.title === arm.title && item.description === arm.description
  })
}

export const orphanCommentKeys = {
  pf: "root_results_participant_flow",
  bc: "root_results_baseline_characteristics",
  om: "root_results_outcome_measures",
  ae: "root_results_adverse_events",
}
